<template>
  <div>
    <div class="landing">
      <div class="row web-only" style="padding-top: 25vh; padding-bottom: 21vh; padding-left: 10%; padding-right: 10%; width: 100%;">
        <div class="col-lg-6 col-md-7 my-auto">
          <!-- <h1 style="font-weight: 900; margin-bottom: 15px;">Own your industry</h1> -->
          <h1 style="font-weight: 900; margin-bottom: 8px;">Be a Modern Recruiter</h1>
          <div class="web-only">
            <!-- <h3 style="margin-bottom: 4px;">With the website solution for recruiters</h3> -->
            <h3 style="margin-bottom: 4px;">With the website solution built for</h3>
            <h3>solo and small staffing operations.</h3>
          </div>
          <p style="font-size: 1.2rem; margin-top: 30px; margin-bottom: 2px;">Transform your business with a custom recruitment platform.</p>
          <p style="font-size: 1.2rem; margin-bottom: 2px;">Offer candidates and clients a seamless experience and</p>
          <p style="font-size: 1.2rem;" class="mb-5">establish your brand as the go to for your niche.</p>
        </div>
        <div class="col-lg-6 col-md-5 my-auto web-only" style="">
          <img src="../assets/img/home/landing/AdobeStock_285202108_panel_iconcolors2.svg" width="100%" height="" alt="digital recruitment platform">
          <!-- <img src="../assets/img/home/landing/AdobeStock_285202108_monitor.svg" width="100%" height="" alt="Enginehire" style="" id='nav-logo'> -->
        </div>
      </div>

      <div class="mobile-only" style="padding-top: 16vh; padding-bottom: 14vh; padding-left: 10%; padding-right: 10%; width: 100%; text-align: center;">
        <!-- <h1 style="font-weight: 900; margin-bottom: 15px;">Own your industry</h1> -->
        <h1 style="font-weight: 900; margin-bottom: 15px;">Be a Modern Recruiter</h1>
        <!-- <h3 class="mobile-only" style="margin-bottom: 4px;">With the website solution for recruiters and small staffing operations.</h3> -->
        <h3 class="mobile-only" style="margin-bottom: 4px;">With the website solution built for solo and small staffing operations.</h3>
        <img src="../assets/img/home/landing/AdobeStock_285202108_monitor2_iconcolors3.svg" class="mobile-only" style="margin-top: 30px; display: block; text-align: center; margin-left: auto; margin-right: auto;" width="100%" height="" alt="digital recruitment platform">
        <p style="font-size: 1.2rem; margin-top: 30px; margin-bottom: 2px; text-align: center;">Transform your business with a custom recruitment platform. Offer candidates and clients a seamless experience and establish your brand as the go to for your niche.</p>
      </div>

    </div>
    <div style="margin-top: 15vh; margin-bottom: 17vh; padding-left: 10%; padding-right: 10%;">
      <h3 style="text-align: center;" class="mb-3">Enginehire is a complete website system for managing your recruitment business</h3>
      <h5 style="text-align: center; font-weight: 300;">We take care of all of your technological operations and automation, so you can take care of the people.</h5>
      <!-- <div class="row mt-5" style="padding-left: 10%; padding-right: 10%;"> -->
        <!-- <div class="col-lg-3">
          <vue-flip :active-hover="true" width="200px" height="50px" style="background-color: green;">
            <template v-slot:front class="front" style="background-color: green;">
              front
            </template>
            <template v-slot:back class="back">
              back
            </template>
          </vue-flip>
        </div> -->
        <!-- <div class="col-lg-3">
          <div class="feature-card">
            <img src="../assets/img/home/icons/beautifulwebsite.svg" width="" height="" alt="digital recruitment platform">
            <h4 class="feature-card-title">Beautiful Website</h4>
            <p>Custom designed for you</p>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="feature-card">
            <img src="../assets/img/home/icons/creditcards.svg" width="" height="" alt="digital recruitment platform">
            <h4 class="feature-card-title">Integrated Payments</h4>
            <p>Don't waste time on invoices</p>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="feature-card">
            <img src="../assets/img/home/icons/creditcards.svg" width="" height="" alt="digital recruitment platform">
            <h4 class="feature-card-title">Integrated Payments</h4>
            <p>Don't waste time on invoices</p>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="feature-card">
            <img src="../assets/img/home/icons/creditcards.svg" width="" height="" alt="digital recruitment platform">
            <h4 class="feature-card-title">Integrated Payments</h4>
            <p>Don't waste time on invoices</p>
          </div>
        </div> -->
      <!-- </div> -->

      <!-- <div class="row mt-5" style="padding-left: 10%; padding-right: 10%;">
        <div class="col-lg-3">
          <div class="feature-card">
            <img src="../assets/img/home/icons/creditcards.svg" width="" height="" alt="digital recruitment platform">
            <h4 class="feature-card-title">Integrated Payments</h4>
            <p>Don't waste time on invoices</p>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="feature-card">
            <img src="../assets/img/home/icons/creditcards.svg" width="" height="" alt="digital recruitment platform">
            <h4 class="feature-card-title">Integrated Payments</h4>
            <p>Don't waste time on invoices</p>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="feature-card">
            <img src="../assets/img/home/icons/creditcards.svg" width="" height="" alt="digital recruitment platform">
            <h4 class="feature-card-title">Integrated Payments</h4>
            <p>Don't waste time on invoices</p>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="feature-card">
            <img src="../assets/img/home/icons/creditcards.svg" width="" height="" alt="digital recruitment platform">
            <h4 class="feature-card-title">Integrated Payments</h4>
            <p>Don't waste time on invoices</p>
          </div>
        </div>
      </div> -->

      <div class="card-deck mt-4">
        <div class="card">
          <img class="card-img-top" src="../assets/img/home/icons/beautifulwebsite.svg" alt="Card image cap">
          <div class="card-body">
            <h4 class="card-title">Beautiful Website</h4>
            <p class="card-text">Custom designed for you</p>
          </div>
        </div>
        <div class="card">
          <img class="card-img-top" src="../assets/img/home/icons/userprofiles3.1.svg" alt="Card image cap">
          <div class="card-body">
            <h4 class="card-title">Custom User Profiles</h4>
            <p class="card-text">Like your own LinkedIn</p>
          </div>
        </div>
        <div class="card">
          <img class="card-img-top" src="../assets/img/home/icons/briefcase.svg" alt="Card image cap">
          <div class="card-body">
            <h4 class="card-title">Job Postings</h4>
            <p class="card-text">Attract the best applicants</p>
          </div>
        </div>
        <div class="card">
          <img class="card-img-top" src="../assets/img/home/icons/digitalassessments.svg" alt="Card image cap">
          <div class="card-body">
            <h4 class="card-title">Digital Screening</h4>
            <p class="card-text">Objectively evaluate candidate skills</p>
          </div>
        </div>
      </div>
      <div class="card-deck">
        <div class="card">
          <img class="card-img-top" src="../assets/img/home/icons/SMS.svg" alt="Card image cap">
          <div class="card-body">
            <h4 class="card-title">Email+SMS Automation</h4>
            <p class="card-text">Only talk to interested people</p>
          </div>
        </div>
        <div class="card">
          <img class="card-img-top" src="../assets/img/home/icons/blogwriting.svg" alt="Card image cap">
          <div class="card-body">
            <h4 class="card-title">Blog and Events</h4>
            <p class="card-text">Build your brand & community</p>
          </div>
        </div>
        <div class="card">
          <img class="card-img-top" src="../assets/img/home/icons/creditcards.svg" alt="Card image cap">
          <div class="card-body">
            <h4 class="card-title">Integrated Payments</h4>
            <p class="card-text">Don't waste time on invoices</p>
          </div>
        </div>
        <div class="card">
          <img class="card-img-top" src="../assets/img/home/icons/analytics.svg" alt="Card image cap">
          <div class="card-body">
            <h4 class="card-title">Data and Analytics</h4>
            <p class="card-text">Make informed decisions</p>
          </div>
        </div>
      </div>
      <!-- <h4 style="text-align: center; margin-top: 55px;" class="web-only">Imagine the functionality of LinkedIn, Indeed, ZipRecruiter and more</h4>
      <h4 style="text-align: center;" class="mb-3 web-only">rolled into your custom website.</h4> -->
      <!-- <h5 style="text-align: center; margin-top: 50px;" class="web-only">Imagine the functionality of LinkedIn, Indeed, ZipRecruiter and more rolled into your custom website.</h5> -->
      <!-- <h5 style="text-align: center; margin-top: 50px;" class="mobile-only">Imagine the functionality of LinkedIn, Indeed, ZipRecruiter and more rolled into your custom website.</h5> -->
    </div>
    <div style="padding-top: 15vh; padding-bottom: 15vh; padding-left: 10%; padding-right: 10%; background-color: #eaf4fe;">
      <!-- <div class="row">
        <div class="col-lg-6" style="">
          <h5 class="mb-4">Our team will work with you to understand the information you need to capture from your candidates, clients and postings, as well as the message you want your website to communicate. We’ll plug in any of your data and get your custom recruitment platform website up and running!</h5>
          <hr>
        </div>
        <div class="col-lg-6">
          <img class="customer-image" style="float: right;" src="../assets/img/home/customers/Hayley.jpg" width="" height="" alt="Hayley">
          <h3>Meet Hayley</h3>
        </div>
      </div> -->

      <h3 style="text-align: center;" class="mb-3">Meet recruiters like you running their businesses on Enginehire</h3>
      <h5 style="text-align: center; font-weight: 300;">Visit their platforms and imagine what yours might look like, fully customized and optimized!</h5>
      <div class="card-deck mb-1">
        <div class="card testimonial-card">
          <img class="card-img-top" src="../assets/img/home/customers/Hayley2.jpg" alt="Card image cap">
          <div class="card-body">
            <h4 class="card-title">Meet Hayley</h4>
            <p class="card-text">CEO of ThriveHire - Recruitment for the global health community</p>
            <h5 class="center pb-2" style="font-weight: 300; max-width: 800px; font-style: italic">It’s been a great opportunity working with EngineHire to build our platform. Their team have been extremely responsive to any of our requests. Their professionalism is top-notch, and they are always open to customizing our platform to best fit the needs of our organization. We highly recommend their work!</h5>
            <div class="visit-platform-button">
              <a class="mylisting-button light-button shadow" href="https://www.thrivehire.co" target="_blank">Visit My Platform</a>
            </div>

          </div>
        </div>
      </div>
      <div class="card-deck mb-5">
        <div class="card testimonial-card">
          <img class="card-img-top" src="../assets/img/home/customers/Steven2.jpg" alt="Card image cap">
          <div class="card-body">
            <h4 class="card-title">Meet Steven</h4>
            <p class="card-text">Co-Owner of PharmaShyft - Recruitment platform for pharmacists</p>
            <div class="visit-platform-button">
              <a class="mylisting-button light-button shadow" href="https://www.pharmashyft.com" target="_blank">Visit My Platform</a>
            </div>
          </div>
        </div>
        <div class="card testimonial-card">
          <img class="card-img-top" src="../assets/img/home/customers/Daniel_heart.jpg" alt="Card image cap">
          <div class="card-body">
            <h4 class="card-title">Meet Daniel</h4>
            <p class="card-text">CEO of Dame Una Mano - Recruiting in-home caregivers for the elderly</p>
            <div class="visit-platform-button">
              <a class="mylisting-button light-button shadow" href="https://www.serviciosdum.com" target="_blank">Visit My Platform</a>
            </div>
          </div>
        </div>
        <div class="card testimonial-card">
          <img class="card-img-top" src="../assets/img/home/customers/Alex.jpg" alt="Card image cap">
          <div class="card-body">
            <h4 class="card-title">Meet Alex</h4>
            <p class="card-text">CEO of LocalStudent - Helping students find work in their community</p>
            <div class="visit-platform-button">
              <a class="mylisting-button light-button shadow" href="https://www.localstudent.ca" target="_blank">Visit My Platform</a>
            </div>
          </div>
        </div>
      </div>

      <div class="center" style="margin-top: 12vh;">
        <h2>Ready to begin your digital transformation?</h2>
        <h4 style="font-weight: 300;" class="web-only mt-3">Get in touch: info@enginehire.io | 1855 775 4473</h4>
        <h4 style="font-weight: 300;" class="mobile-only mt-3">Get in touch:</h4>
        <h5 style="margin-top: 10px; font-weight: 300;" class="mobile-only">1855 755 4473 | info@enginehire.io</h5>
        <div class="" style="margin-top: 33px;">
          <!-- <a class="mylisting-button light-button shadow" href="https://www.enginehire.io/contact/">Book a Demo</a> -->
          <router-link :to="{ name: 'Contact' }" class="mylisting-button light-button shadow">Book a Demo</router-link>
        </div>
      </div>

      <!-- <div style="background-color: #1f4e78; color: white; text-align: center; max-width: 500px; display: block; margin-left: auto; margin-right: auto;" class="py-4 shadow"> -->
        <!-- <h4>Starting as low as</h4> -->
        <!-- <h4 style="border-bottom: 1px solid white; padding-bottom: 20px;"><span style="font-size: 3rem;">$99</span> /month</h4> -->
        <!-- <div class="web-only">
          <h5 style="margin-top: 20px; margin-bottom: 0;">Includes design, development, hosting,</h5>
          <h5 style="border-bottom: 1px solid white; padding-bottom: 20px;">support, maintenance, updates and more!</h5>
        </div>
        <h5 class="mobile-only" style="margin-top: 20px; margin-bottom: 0;">Includes design, development, hosting, support, maintenance, updates and more!</h5>
        <button style="margin-top: 20px;" class="mylisting-button light-button">Book a Demo</button>
        <h5 style="margin-top: 20px;">1855 755 4473 | info@enginehire.io</h5> -->
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import VueFlip from 'vue-flip';

export default {
  components: {
    'vue-flip': VueFlip
  }
}
</script>

<style>
.landing {
  /* height: 100vh; */
  background-color: var(--shopify);
  background-color: #fcbf67;
  width: 100%;
}

.feature-card {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
  /* margin-left: 10px; */
  /* margin-right: 10px; */
  /* max-width: 20%; */
  /* width: 99%; */
  /* border: 1px solid gray; */
  box-shadow: 0 .5rem 1rem rgba(0,0,0,.15);
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
.card {
  padding-top: 30px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
  /* margin-left: 10px; */
  /* margin-right: 10px; */
  /* max-width: 20%; */
  /* width: 99%; */
  /* border: 1px solid gray; */
  box-shadow: 0 .5rem 1rem rgba(0,0,0,.15);
  text-align: center;
  margin-top: 25px;
  /* margin-left: auto; */
  /* margin-right: auto; */

  border: none;
}
.feature-card img {
  text-align: center;
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 170px;
}
.card img {
  text-align: center;
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 170px;
}
.feature-card-title {
  margin-top: 15px;
}

.testimonial-card {
  /* background-color: #eaf4fe; */
}
.testimonial-card img {
  height: 150px;
  width: 150px;
  border-radius: 50%;
}

.customer-image {
  border-radius: 50%;
  width: 150px;
}

.visit-platform-button {
  margin-top: 33px;
  margin-bottom: 12px;
}

/* ------------------- SMALL -------------------- */
@media (max-width: 768px) {

  .card {
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue